import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  ApartmentOutlined,
  InfoOutlined,
  KeyboardArrowDownOutlined,
  LocationOnOutlined,
} from "@mui/icons-material";
import { CalendarMonthOutlined } from "@mui/icons-material";
import { yearInfo } from "components/data/headerInfo";
import {
  setLocation,
  setYear,
  setQuarter,
  setCountryCode,
} from "state/emissionSlice";
import MonthButton from "components/MonthButton";
import { useNavigate } from "react-router-dom";
import { hierarchy } from "components/data/hierarchy";
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

import { Energydata } from "components/data/info/energydata";

const EnergyHeaderSection = ({ monthsCalculated }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);


  const token = useSelector((state) => state.auth.authToken);

  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + token,
      "Content-type": "application/json",
    },
  };

  // locations

  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [selectedYear, setSelectedYear] = useState("");

  const navigate = useNavigate();

  const year = useSelector((state) => state.emission.year);
  useEffect(() => {
    setSelectedYear(year);
  }, [year]);

  // const fetchLocations = () => {
  //   axios
  //     .get(
  //       'http://bmw.sustainext.staging.azte.in/api/v1/organisation/location-of-operation/',
  //       axiosConfig
  //     )
  //     .then((response) => {
  //       setLocations(response.data, 'locations');
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data: ', error);
  //     });
  // };

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };

  useEffect(() => {
    fetchHierarchy();
  }, []);

  function fetchHierarchy() {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/structure`, axiosConfig)
      .then((response) => {
        const data = response.data;
        const filtered = filterData(data);
        console.log(filtered);
        setLocations(filtered);
        setSelectedLocation(filtered[0]);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }

  function filterData(data) {
    const extractedData = data.reduce((acc, item) => {
      const locations = item.corporatenetityorg.flatMap((entity) =>
        entity.location.map((location) => ({
          id: location.id,
          name: location.name,
          Address: location.address,
          Country: location.country,
          state: location.state,
          revenue: location.revenue,
          amount: location.amount,
          area: location.area,
          sector: location.sector,
          City: location.city,
          "Corporate Entity": location.corporate_entity,
          businessActivities: location.type_of_business_activities,
          productTypes: location.type_of_product,
          serviceTypes: location.type_of_services,
        }))
      );
      return [...acc, ...locations];
    }, []);

    return extractedData;
  }

  // function extractLocations(hData) {
  //   const allLocations = [];
  //   hData.forEach((org) => {
  //     org.corporate_entities.forEach((entity) => {
  //       entity.location_of_operations.forEach((location) => {
  //         allLocations.push(location);
  //       });
  //     });
  //   });
  //   setLocations(allLocations);
  // }

  // useEffect(() => {
  //   // fetchHierarchy();
  //   extractLocations(hierarchy);
  // }, []);

  // useEffect(() => {
  //   fetchLocations();
  // }, []);

  //quarter
  // const [quarter, setQuarterState] = useState('');
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const handleMonthClick = (month) => {
    dispatch(setQuarter(month));
  };

  const handleLocationChange = (event) => {
    const location = event.target.value;
    dispatch(setLocation(location));
    const foundLocation = locations.find((loc) => loc.name === location);
    setSelectedLocation(foundLocation);

    const code = foundLocation.country;
    console.log({ foundLocation });
    dispatch(setCountryCode(code));
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    dispatch(setYear(year));
    setSelectedYear(year);
  };
  const [data, setData] = useState();

  const [category, setCategory] = useState("");
  const toggleDrawerclose =() =>{
      setIsOpen(!isOpen);
  }
  const toggleDrawer = (selected) => {
    setIsOpen(!isOpen);
    setCategory(selected);
  };


  useEffect(()=>{
    var newData = [];
    Energydata.map((program)=>{
      program.category.map((tag)=>{
        if(tag === category){
          newData.push(program);
        }
      })
    })
    // //console.log(newData);
    setData(newData);
  },[category])
  return (
    <>
    <div className="flex flex-col justify-start mx-2 mb-14">
      <div className="flex justify-between  items-center mb-6">
        <div className="">
          <h1 className="gradient-text mb-4 text-[1.375rem] font-bold">
            Energy
          </h1>
          <h5 className="font-lg font-medium text-gray-500 text-[0.625rem] -mt-4 ">
            <InfoOutlined style={{ fontSize: "0.625rem" }} />
            The data that falls under waste category are uploaded here.
          </h5>
        </div>
        <div className="flex  absolute right-[4.5rem]">
            <button className="text-[#007EEF] bg-slate-200 rounded-full text-[11px] w-[60px] h-[25px]" onClick={()=>toggleDrawer('1')}>GRI 302-1</button>
            <button className="text-[#fff] bg-amber-400 rounded-full text-[11px] w-[60px] h-[25px] ml-2 " onClick={()=>toggleDrawer('2')}>SDG 7</button>
            <button className="text-[#fff] bg-red-900 rounded-full text-[11px] w-[60px] h-[25px] ml-2" onClick={()=>toggleDrawer('3')}>SDG 8</button>
            <button className="text-[#fff] bg-yellow-600 rounded-full text-[11px] w-[60px] h-[25px] ml-2 "onClick={()=>toggleDrawer('4')}>SDG 12</button>
            <button className="text-[#fff] bg-lime-900 rounded-full text-[11px] w-[60px] h-[25px] ml-2" onClick={()=>toggleDrawer('5')}>SDG 13</button>
        </div>
      </div>
      <div className="border-t">
        <div className="flex space-x-4 mt-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <LocationOnOutlined
                className="text-neutral-500"
                style={{ fontSize: "16px" }}
              />
            </div>
            <select
              className="w-[163px] border appearance-none text-xs text-neutral-500 m-0.5 pr-8 rounded-md py-2 pl-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer"
              onChange={handleLocationChange}
            >
              <option value="">Select Location</option>
              {locations.map(({ name }) => (
                <option value={name}>{name}</option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-2 flex items-center pl-3 pointer-events-none">
              <KeyboardArrowDownOutlined
                className="text-neutral-500"
                style={{ fontSize: "16px" }}
              />
            </div>
          </div>
          <div className="relative ">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <CalendarMonthOutlined
                className="text-neutral-500"
                style={{ fontSize: "16px" }}
              />
            </div>
            <select
              className="w-[152px] border appearance-none text-xs text-neutral-500 m-0.5 pr-8 rounded-md py-2 pl-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer"
              value={selectedYear}
              onChange={handleYearChange}
            >
              <option value="">Select Year</option>
              {yearInfo.map((item) => (
                <option value={item.slice(0, 4)}>{item}</option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-2 flex items-center pl-3 pointer-events-none">
              <KeyboardArrowDownOutlined
                className="text-neutral-500"
                style={{ fontSize: "16px" }}
              />
            </div>
          </div>
          <div className="absolute -right-10 w-[400px] h-6 px-1 py-[3px] bg-white bg-opacity-10 rounded-lg justify-start items-center inline-flex">
            {/* <div className='text-neutral-500 text-sm font-bold leading-[15px] flex'>
              <ApartmentOutlined className='me-1 -mt-1' />
              <div>
                Corporate Entity:{' '}
                {selectedLocation.name && (
                  <span className='text-neutral-500 border px-2 py-1 rounded-lg border-stone-300'>
                    {selectedLocation?.corporate_entity?.legal_name}{' '}
                  </span>
                )}
              </div>
            </div> */}
          </div>
        </div>
        <div className="flex justify-center  items-center mt-6  w-[775px] h-9 rounded-md">
          {months.map((month) => (
            <MonthButton
              month={month}
              handleMonthClick={handleMonthClick}
              monthsCalculated={monthsCalculated}
            />
          ))}
        </div>
      </div>
      <div>
        {/* <h4 className='font-lg font-medium mb-4 ms-2'>Corporate Entity :</h4>
        {selectedLocation.name && (
          <p className='text-[#007EEF] border px-2 py-1 rounded-md'>
            {selectedLocation?.corporate_entity?.legal_name}
          </p>
        )} */}
      </div>
      <div className={`${isOpen ? "translate-x-0" : "translate-x-[105%]"} 
          absolute right-[51px]  w-[340px] h-full bg-white  rounded-md 
          transition-transform duration-300 ease-in-out z-[100] shadow-2xl px-2`}>

{data && data.map((program)=>(
  <>
   <div className="flex p-2 pt-5 pb-4 border-b-2 ">
   <div className="ml-2">
  {program.header}
   </div>
   <div className="ml-[150px]">
     <h5 className="text-[#727272] text-[17px] font-bold"><InsertLinkOutlinedIcon/></h5>
   </div>
   <div className="ml-2">
     <h5 className="text-[#727272] text-[17px] font-bold cursor-pointer" onClick={toggleDrawerclose}><ClearOutlinedIcon/></h5>
   </div>

 </div>
             <div> {program.data}</div>
             </>
                ))}

      </div>
    </div>
  
   
    </>
  );
};

export default EnergyHeaderSection;
